export function tagColors(tag: Pick<DatabaseTable<"tags">, "color">) {
  return {
    bgColor: hexToHSLA(tag.color, { luminance: 90, saturation: 75 }),
    textColor: hexToHSLA(tag.color, { luminance: 20, saturation: 75 }),
    bdColor: hexToHSLA(tag.color, { luminance: 85, saturation: 50 }),
  };
}
